export default function formatFixedDecimal(value: number): number {
  return +value.toFixed(2)
}
